/* ================================================================
   AISTROWISE — Horóscopo semanal behaviour (no libraries, deferred)
   1. Mobile sticky bar: visible once the hero CTA scrolls past and the
      plans block is not on screen.
   2. Sample-week modal open/close (theme-style, [data-aw-modal]).
   ================================================================ */
(function () {
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Publish the visible sticky-bar height so the WhatsApp bubble can ride above
  // it (this bar is taller than the PDP bar — its CTA wraps to two lines). Read
  // only on show/hide change, so no per-scroll reflow.
  function awBubbleBar(bar, show) {
    var root = document.documentElement;
    if (show) {
      root.style.setProperty('--aw-bar-h', bar.offsetHeight + 'px');
      document.body.classList.add('aw-bar-shown');
    } else {
      document.body.classList.remove('aw-bar-shown');
      root.style.removeProperty('--aw-bar-h');
    }
  }

  function initBar(root) {
    var bar = root.querySelector('[data-aw-hps-bar]');
    var heroCta = root.querySelector('[data-aw-hps-herocta]');
    var plans = root.querySelector('[data-aw-hps-plans]');
    if (!bar || !plans) return;
    var lastShow = null;
    function update() {
      var vh = window.innerHeight;
      var heroPast = heroCta ? heroCta.getBoundingClientRect().bottom < vh * 0.55 : window.scrollY > vh * 0.6;
      var p = plans.getBoundingClientRect();
      var plansVisible = p.top < vh && p.bottom > 0;
      var show = heroPast && !plansVisible;
      if (show === lastShow) return;
      lastShow = show;
      bar.classList.toggle('is-show', show);
      awBubbleBar(bar, show);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initPlans(root) {
    // Native plan picker (aw-plan-picker snippet): radios named selling_plan
    // inside each card form, so the CTA posts the chosen plan with no JS.
    // Here we only swap the card's displayed monthly price on change.
    each(root.querySelectorAll('[data-card]'), function (card) {
      var radios = card.querySelectorAll('[data-aw-plan-radio]');
      if (!radios.length) return;
      var article = card.closest('.aw-hps-plan');
      var price = article ? article.querySelector('.aw-hps-plan__price b') : null;
      each(radios, function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var display = radio.getAttribute('data-plan-display');
          // data-plan-display lleva el marcado de aw-price (cifra + etiqueta ISO).
          if (display && price) price.innerHTML = display;
        });
      });
    });
  }

  ready(function () {
    each(document.querySelectorAll('[data-aw-hps]'), initBar);
    each(document.querySelectorAll('[data-aw-hps]'), initPlans);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest && e.target.closest('[data-aw-modal-open]');
      if (opener) {
        var m = document.getElementById(opener.getAttribute('data-aw-modal-open'));
        if (m) {
          var wasHidden = m.hidden;
          m.hidden = false; document.body.style.overflow = 'hidden';
          if (wasHidden && window.awTrack) window.awTrack('horoscopo_sample_open'); // once per open
        }
        return;
      }
      var closer = e.target.closest && e.target.closest('[data-aw-modal-close]');
      if (closer) {
        var modal = closer.closest('[data-aw-modal]');
        if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
        return;
      }
      // click on the overlay backdrop (outside the card) closes
      if (e.target.matches && e.target.matches('[data-aw-modal]')) {
        e.target.hidden = true; document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        each(document.querySelectorAll('[data-aw-modal]:not([hidden])'), function (m) {
          m.hidden = true; document.body.style.overflow = '';
        });
      }
    });
  });
})();
